import { Colors, Language, Lightning, Router, Utils, Log } from '@lightningjs/sdk'
import SearchItem from '../components/coverItems/SearchItem'
import Keyboard from '../components/keyboard/Keyboard'
import EpisodeList from '../components/lists/EpisodeList'
import Loader from '../components/Loader2'
import { getPodcastSearch } from '../lib/api/Api'
import { isFilledArray } from '../lib/AppHelpers'
import { appSettings } from '../lib/AppSettings'
import ImageItemWrapper from '../lib/ui/helpers/ImageItemWrapper'

export default class Search extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      Loader: { x: 435, y: 800, type: Loader, zIndex: 200, alpha: 0 },
      SearchResult: {
        x: 968,
        y: 116,
        w: 800,
        h: 960,
        type: EpisodeList,
        direction: 'vertical',
        autoResize: false,
        spacing: 40,
        scrollOffset: 40,
        signals: { indexChanged: true },
      },
      NoData: {
        w: 700,
        h: 110,
        x: 934,
        y: 143,
        visible: false,
        Message: {
          w: 700,
          h: 50,
          color: 0xffffffff,
          text: {
            text: Language.translate('SearchNoData'),
            fontSize: 35,
            fontFace: 'OpenSansRegular',
            lineHeight: 50,
          },
        },
        SearchTerm: {
          w: 900,
          h: 100,
          y: 60,
          color: 0xffffffff,
          text: {
            text: this._searchTerm,
            fontSize: 35,
            fontFace: 'OpenSansBold',
            wordWrapWidth: 900,
            maxLines: 2,
            lineHeight: 50,
          },
        },
      },
      KeyboardBackground: {
        x: 250,
        y: 218,
        w: 546,
        h: 455,
        src: Utils.asset('images/keyboard/KeyboardNumBG.png'),
      },
      Keyboard: {
        x: 260,
        y: 228,
        w: 530,
        h: 420,
        type: Keyboard,
        layout: 'search',
        signals: { valueChanged: true },
      },
      InputShadow: {
        w: 550,
        h: 110,
        x: 260,
        y: 116,
        alpha: 0.5,
        texture: Lightning.Tools.getShadowRect(530, 90, 5, 21, 23),
        color: Colors('black').get(),
      },
      InputField: {
        w: 530,
        h: 90,
        x: 260,
        y: 116,
        rect: true,
        color: Colors('SearchInput').get(),
        shader: { type: Lightning.shaders.RoundedRectangle, w: 530, h: 90, radius: 5 },
        SearchTextWrapper: {
          w: 457,
          h: 41,
          x: 32,
          y: 25,
          clipping: true,
          SearchText: {
            h: 41,
            rtt: true,
            text: {
              text: '',
              textAlign: 'left',
              fontSize: 30,
              lineHeight: 40,
              fontFace: 'OpenSansSemibold',
            },
          },
        },
      },
    }
  }

  set searchTerm(searchTerm) {
    this._searchTerm = searchTerm

    appSettings.searchState.searchTerm = searchTerm

    this.tag('Keyboard').value = searchTerm

    this.updateSearchBar()
  }

  get searchTerm() {
    return this._searchTerm
  }

  set searchResult(result) {
    appSettings.searchState.isSearch = false
    appSettings.searchState.searchTerm = null

    this.tag('Loader').stop()

    if (result && result.podcasts && isFilledArray(result.podcasts)) {
      appSettings.searchState.isSearchData = true
      appSettings.searchState.searchTerm = this.searchTerm

      this.noData = false

      this.tag('SearchResult').visible = true

      this._results = result.podcasts

      const dataType = result.type
      this.tag('SearchResult').reset()
      this.tag('SearchResult').items = this._results.map(item => {
        item.type = dataType
        return {
          ref: `Podcast-${item.id}`,
          w: 800,
          h: 195,
          sizes: { h1: 195, h2: 320 },
          type: ImageItemWrapper,
          itemType: SearchItem,
          item,
        }
      })

      this.tag('SearchResult').visible = true

      this.tag('NoData').patch({
        visible: false,
        SearchTerm: { text: { text: '' } },
      })

      this._setState('Keyboard')
    } else {
      appSettings.searchState.isSearchData = true

      this._results = {}

      this.tag('NoData').patch({
        visible: true,
        SearchTerm: { text: { text: this.searchTerm } },
      })

      this.tag('SearchResult').visible = false

      this._setState('Keyboard')
    }
  }

  resetKeyboardInputValue() {
    this.tag('Keyboard').value = ''
  }

  setKeyboardInputValue(v) {
    this.tag('Keyboard').value = v
  }

  _init() {
    this._searchTerm = ''
    this._isSearching = false

    this.setKeyboardInputValue(this._searchTerm)

    this._setState('Keyboard')
    this.tag('SearchText').on('txLoaded', () => {
      if (this.tag('SearchText').finalW > 457) {
        this.tag('SearchText').x = 457 - this.tag('SearchText').finalW
      } else {
        this.tag('SearchText').x = 0
      }
    })
  }

  _active() {
    if (
      appSettings &&
      appSettings.searchState &&
      appSettings.searchState.searchTerm &&
      appSettings.searchState.searchTerm > ''
    ) {
      this.searchTerm = appSettings.searchState.searchTerm

      this._getSearchResults()
    }
  }
  _inactive() {
    this.stage.gc()
  }
  updateSearchBar() {
    let inp

    if (this.tag('Keyboard').value.length > 0) {
      inp = this.tag('Keyboard').value

      this.tag('SearchTerm').text = inp
    } else {
      inp = Language.translate('SearchPodcast')

      this.tag('NoData').patch({
        visible: false,
        SearchTerm: { text: { text: '' } },
      })
    }

    this.tag('SearchText').text = inp
  }

  _getSearchResults() {
    this._isSearching = true
    this._searchTimeStamp = Date.now()

    getPodcastSearch(this.searchTerm, this._searchTimeStamp).then(results => {
      if (this._searchTimeStamp === results.searchTimeStamp) {
        this.searchResult = results.searchResult
      }

      this._isSearching = false
    })
  }

  _handleBack() {
    Log.info('Search:HandleBack')
    appSettings.searchState.searchTerm = null

    Router.back()
  }

  static _states() {
    return [
      class Searching extends this {
        $enter() {
          this.tag('Loading').alpha = 1
        }

        $exit() {
          this.tag('Loading').alpha = 0
        }
      },

      class Keyboard extends this {
        $enter() {
          this.updateSearchBar()
        }

        valueChanged() {
          this.updateSearchBar()

          this.searchTerm = this.tag('Keyboard').value

          if (this.searchTerm && this.searchTerm.length >= 3) {
            this.tag('Loader').start()

            this._getSearchResults()
          } else {
            this._searchTimeStamp = null
            this.tag('SearchResult').items = []

            this.tag('SearchResult').visible = false
          }
        }

        _handleRight() {
          if (this._isSearching) {
            return
          }

          if (this._results && this._results.length > 0 && this.tag('SearchResult').visible) {
            this._setState('SearchResult')
          }
        }

        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _getFocused() {
          return this.tag('Keyboard')
        }
      },

      class SearchResult extends this {
        $enter() {
          if (this.tag('SearchResult').items.length > 0) {
            // this.tag("SearchResult").episodeItem(this.tag("SearchResult").index).child._showLargeSmall(true);
          } else {
            this._setState('Idle')
          }

          this.tag('SearchResult')._reposition()
        }

        $exit() {
          // this.tag("SearchResult").episodeItem(this.tag("SearchResult").index).child._showLargeSmall(false);
          this.tag('SearchResult').unfocusList()
        }

        _handleLeft() {
          this._setState('Keyboard')
        }

        _getFocused() {
          return this.tag('SearchResult')
        }
      },
    ]
  }
}
